export default "__VITE_ASSET__Bmci1qUg__"